import {ExtendedError} from '../../../../libs/shared/helpers/src/types/customErrors';
import {reportToBugsnag} from '../../../../srcCommon/services/bugsnag/bugsnag';
import {ActionWithPayload} from '../../../helpers/reduxHelpers';
import {ApiJob, ApiJobInInbox, JobModel} from '../../../models/api/jobModel';
import {patchApiAsync, postApiAsync} from '../../../services/http/http';
import {HttpNetworkError, HttpTimeoutError} from '../../../services/http/httpError';
import {ThunkAsyncAction} from '../../appThunk';
import {getCompanyUrl} from '../company/companySelectors';

/*
 * Action types.
 */

export enum JobsActionsEnum {
  JOB_UPDATED = '@@data/jobs/JOB_UPDATED',
  JOB_DELETED = '@@data/jobs/JOB_DELETED',
}

/*
 * Types.
 */

export interface JobUpdatedAction extends ActionWithPayload<JobModel> {
  type: JobsActionsEnum.JOB_UPDATED;
}

export interface JobDeletedAction extends ActionWithPayload<number> {
  type: JobsActionsEnum.JOB_DELETED;
}

/*
 * Action creators.
 */

export function jobUpdatedAction(job: JobModel): JobUpdatedAction {
  return {
    type: JobsActionsEnum.JOB_UPDATED,
    payload: job,
  };
}

export function jobDeletedAction(jobId: number): JobDeletedAction {
  return {
    type: JobsActionsEnum.JOB_DELETED,
    payload: jobId,
  };
}

export function stopJobAsyncAction(jobId: number): ThunkAsyncAction {
  return async (dispatch, getState) => {
    const state = getState();
    const companyUrl = getCompanyUrl(state);

    try {
      const url = `${companyUrl}/jobs/${jobId}`;
      const body = {action: 'stop'};

      const job = await patchApiAsync(ApiJob, url, body);

      dispatch(jobUpdatedAction(job));
    } catch (error) {
      const isNetworkError = error instanceof HttpNetworkError || error instanceof HttpTimeoutError;
      if (isNetworkError) {
        return;
      }

      reportToBugsnag(new ExtendedError('Failed to stop select all job.', error));
    }
  };
}

/*
 * Base actions.
 */

export function createMassArchiveJobAsyncAction(inboxUrl: string, beforeDate: number): ThunkAsyncAction {
  return async (dispatch) => {
    const url = `${inboxUrl}/jobs`;

    const body = {
      type: 'mass_archive',
      before_date: beforeDate,
    };

    const result = await postApiAsync(ApiJobInInbox, url, body);

    dispatch(jobUpdatedAction(result));
  };
}

/*
 * Union type.
 */

export type JobsAction = JobUpdatedAction | JobDeletedAction;
